import React from 'react';

import { styled } from '@mui/material/styles';
import { isNil } from 'ramda';

import AuxValuesEditForm from './AuxValuesEditForm';
import AuxValuesForm, { IAuxValuesFormProps } from './AuxValuesForm';

const PREFIX = 'EditOrCreate';

const classes = {
  root: `${PREFIX}-root`
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    minWidth: 400
  }
}));

const EditOrCreate: React.FC<IAuxValuesFormProps> = ({ rowId, ...props }) => {


  return (
    (<Root className={classes.root}>
      {isNil(rowId) ? (
        <AuxValuesForm {...props} rowId={rowId} />
      ) : (
        <AuxValuesEditForm {...props} rowId={rowId} />
      )}
    </Root>)
  );
};

export default EditOrCreate;
